"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventButler = void 0;
const student_monitoring_1 = require("@evidenceb/student-monitoring");
const butler_1 = require("./butler");
const interfaces_1 = require("./interfaces");
const ai_toolkit_1 = require("@evidenceb/ai-toolkit");
const rxjs_1 = require("rxjs");
const utils_1 = require("./utils");
const uuid_1 = require("uuid");
const athena_common_1 = require("@evidenceb/athena-common");
function globalErrorHandler(error, athenaEvent, subscriberId) {
    console.group("Unhandled error thrown while processing an AthenaEvent");
    console.log("Error:", error);
    console.log("AthenaEvent:", athenaEvent);
    console.log("Subscriber id:", subscriberId);
    console.groupEnd();
}
class EventButler extends butler_1.Butler {
    constructor(moduleId, listAIEngines, butlerConfig, aiEnginesHistories, eventStream, app, userId, sessionId, workmode, listAIAgents = [interfaces_1.AIAgentsIDs.studentActivityMonitorAgent, interfaces_1.AIAgentsIDs.messageManegementAgent], agentsConfig, args = undefined) {
        super(moduleId, listAIEngines, butlerConfig, aiEnginesHistories, args);
        this.aiAgents = {};
        this.listOfAIAgentsId = [];
        this.count = 0;
        this.aiAgentsConfig = agentsConfig;
        this.workmode = this.convertWorkMode(workmode);
        this.userId = userId;
        this.sessionId = sessionId;
        this.app = app;
        this.stream = eventStream;
        this.localStream = new rxjs_1.Subject();
        this.listAiAgent = listAIAgents;
        this.aiAgents.eventButler = this;
        if (this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.adaptiveTest)) {
            if (this.aiEnginesConfigs.adaptiveTest.adaptiveTestDiagnosis) {
                this.initAgentsFromListAndSubscribeToStream(listAIAgents);
            }
        }
        else if (!this.listOfAIEnginesId.includes(interfaces_1.AIEnginesIDs.cnedAdaptiveTest)) {
            if (!this.isSampleFromInitialTest) {
                this.initAgentsFromListAndSubscribeToStream(listAIAgents);
            }
        }
        this.initEventButler(this);
    }
    convertWorkMode(workMode) {
        const conversionMap = {
            [athena_common_1.WorkModeType.Duo]: "duo",
            [athena_common_1.WorkModeType.SoloAI]: "solo-ai",
            [athena_common_1.WorkModeType.Playlist]: "playlist",
            [athena_common_1.WorkModeType.Tuto]: "tuto",
            [athena_common_1.WorkModeType.Workshop]: "workshop",
            [athena_common_1.WorkModeType.Experimentation]: "experimentation",
            [athena_common_1.WorkModeType.StandaloneAdaptiveTest]: "standalone-adaptive-test",
            [athena_common_1.WorkModeType.Revision]: "revision",
            [athena_common_1.WorkModeType.Test]: "test", // to fix workmode existe in front but not used
        };
        return conversionMap[workMode];
    }
    /****************************** init Agents and stream subscription functions *************************** */
    /**
     * init AiAgent based on given ID
     * @param agentId AiAgent ID
     */
    initAiAgents(agentId) {
        const initAiAgentsDict = {
            [interfaces_1.AIAgentsIDs.studentActivityMonitorAgent]: this.initSAM,
            [interfaces_1.AIAgentsIDs.messageManegementAgent]: this.initMMA,
            [interfaces_1.AIAgentsIDs.eventButler]: this.initEventButler,
        };
        initAiAgentsDict[agentId](this);
    }
    /**
     * subscribe event related tu the EventButler
     */
    initEventButler(eventButler) {
        this.subscribeAIAgentToStream(interfaces_1.AIAgentsIDs.eventButler, eventButler);
    }
    /**
     * init SAM
     */
    initSAM(eventButler) {
        eventButler.aiAgents.studentActivityMonitorAgent = new student_monitoring_1.SAM(eventButler.aiAgentsConfig.studentActivityMonitorAgent.config);
    }
    /**
     * init MMA
     */
    initMMA(eventButler) {
        eventButler.aiAgents.messageManegementAgent = new student_monitoring_1.MMA([]);
    }
    /**
     * init multiple agent from list and subscribe them to the eventStream
     * @param listAIAgents
     */
    initAgentsFromListAndSubscribeToStream(listAIAgents) {
        listAIAgents.forEach((agentIdAIType) => {
            this.initAiAgents(agentIdAIType);
            this.subscribeAIAgentToStream(agentIdAIType, this);
        });
    }
    /**
     * subscribe each agent to its related events defined in AgentsIDsToEventType
     * @param agentId
     * @param eventButler
     */
    subscribeAIAgentToStream(agentId, eventButler) {
        var _a;
        (_a = this.stream) === null || _a === void 0 ? void 0 : _a.registerSubscriber({
            id: agentId + "-" + this.moduleId + "-" + (0, uuid_1.v4)(),
            athenaEventTypeFilter: interfaces_1.AgentsIDsToRelatedEventType[agentId],
            processAthenaEvent(athenaEvent) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (athenaEvent.categoryData && athenaEvent.categoryData.workmode === "playlist") {
                        return;
                    }
                    if (interfaces_1.AgentsIDsToRelatedWorkmode[agentId].includes(athenaEvent.categoryData.workmode) && (0, utils_1.extractModuleId)(athenaEvent) == eventButler.moduleId) {
                        const agent = getAgent(eventButler.aiAgents, agentId);
                        /**@ts-expect-error*/
                        agent.updateFromEvent(athenaEvent, eventButler.stream); // ignored because there are incompatible signatures of the update from event method in various versions of the agent
                    }
                });
            },
        });
    }
    /****************************** AiEngines update with events functions *************************** */
    /**
     * add item to revision spaceegar
     * @param deactivatedItemId
     */
    addActivityTo_revisionAlgSpace(deactivatedItemId) {
        let actId = deactivatedItemId;
        let objId = this.ontology.zpdes.get_objectiveID_of_activity(actId);
        const diff_act = this.ontology.zpdes.computeLinearDifficulties(); //getLinearDiff in ontology
        getEngine(this.aiEngines, interfaces_1.AIEnginesIDs.revisionAlg).add_activity(objId, actId, diff_act[actId], new Date(Date.now()));
    }
    sample_from_history(history) {
        var _a;
        if (history.length > 0) {
            // simulate event emission from player
            history[0].moduleId = this.moduleId;
            if (this.isSampleFromInitialTest) {
                this.isSampleFromInitialTest = this.exercicesManager.history["initialTest"].length < ((_a = this.enginesOntologies.zpdes) === null || _a === void 0 ? void 0 : _a.initialTestDatas["exercises"].length) - 1; // minus 1 bc history is udapted after
                if (!this.isSampleFromInitialTest) {
                    this.initAgentsFromListAndSubscribeToStream(this.listAiAgent);
                }
            }
        }
        this.lastActivity = history[0];
        let activityInfo = this.update_and_nextExercise(history[0]);
        return activityInfo;
    }
    /****************************** Event handling functions *************************** */
    updateFromEvent(event) {
        switch (event.type) {
            case "AICurriculumFinishedEvent":
                let curriculumEvent = event;
                if (curriculumEvent.data.aiEngine == interfaces_1.AIEnginesIDs.adaptiveTest) {
                    // console.log('Adaptive Test finished in', this.count - 1);
                    this.count = 0;
                    this.initAgentsFromListAndSubscribeToStream(this.listAiAgent);
                }
                // else {
                //     console.log('ZPDES finished in', this.count - 1);
                //     this.stream.unregisterSubscriber(AIAgentsIDs.eventButler + "-" + this.moduleId);
                // }
                break;
            case "ResultExerciseEvent":
                this.count++;
                //this.update_and_nextExercise(event.data);
                break;
            // case 'AIEvtShowMessage':
            //     if (event.data.messageType.includes("activityDeactivationMessage")) {
            //         console.log('well done you deactivated an activity');
            //     }
            //     else if (event.data.messageType.includes("objectiveDeactivationMessage")) {
            //         console.log('well done you deactivated an objective');
            //     }
            //     else if (event.data.messageType.includes("activityActivationMessage")) {
            //         console.log('well done you unlocked a new activity');
            //     }
            //     else if (event.data.messageType.includes("objectiveActivationMessage")) {
            //         console.log('well done you unlocked a new objective');
            //     }
            //     else {
            //         console.log('SAM detected', event.data.messageType, 'in', event.data.graphLevel, 'after', this.enginesOntologies.zpdes?.get_code_of_exo(event.data.exerciseId));
            //     }
            //     break;
            // case 'AIEvtZPDESActDeactivated':
            //     this.addActivityTo_revisionAlgSpace(event.data.deactivatedItemId);
        }
    }
    manage_event(eventType, eventData) {
        var _a, _b, _c, _d;
        let lastActivity = (0, ai_toolkit_1.deepCopy)(this.lastActivity);
        //let eventTypeString = deepCopy(eventType)
        switch (String(eventType)) {
            case "AIExerciseChosenEvent":
                let treatedEventData = eventData;
                let exerciseChosenData = {
                    aiEngine: this.aiEngineToSampleActivity,
                    moduleId: this.moduleId,
                    activityId: (_a = treatedEventData.activityId) !== null && _a !== void 0 ? _a : "undefined",
                    objectiveId: (_b = treatedEventData.objectiveId) !== null && _b !== void 0 ? _b : "undefined",
                    exerciseId: (_c = treatedEventData.exerciseId) !== null && _c !== void 0 ? _c : "undefined",
                    isInitialTest: this.isSampleFromInitialTest,
                    isAdaptiveTest: this.aiEngineToSampleActivity == interfaces_1.AIEnginesIDs.adaptiveTest ? true : false,
                    isModuleFinished: (_d = treatedEventData.isInitialTest) !== null && _d !== void 0 ? _d : this.isCurriculumFinished(),
                };
                this.emit_event("AIExerciseChosenEvent", "butler", exerciseChosenData);
                break;
            case "AICurriculumFinishedEvent":
                eventData = eventData;
                let curriculumFinishedData = {
                    aiEngine: this.aiEngineToSampleActivity,
                    moduleId: this.moduleId,
                    objectiveId: lastActivity ? lastActivity.objectiveId : "undefined",
                    activityId: lastActivity ? lastActivity.activityId : "undefined",
                    exerciseId: lastActivity ? lastActivity.exerciseId : "undefined",
                    diagnosis: eventData.diag,
                };
                this.emit_event(String(eventType), "butler", curriculumFinishedData);
                break;
            case "AIActivationEvent":
                eventData = eventData;
                let activationData = {
                    moduleId: this.moduleId,
                    objectiveId: lastActivity.objectiveId,
                    activityId: lastActivity.activityId,
                    exerciseId: lastActivity.exerciseId,
                    activatedItemId: eventData,
                    graphLevel: eventData == lastActivity.objectiveId ? "objective" : "activity",
                    aiEngine: this.aiEngineToSampleActivity,
                };
                this.emit_event(String(eventType), "butler", activationData);
                break;
            case "AIDeactivationEvent":
                eventData = eventData;
                let deactivationData = {
                    moduleId: this.moduleId,
                    objectiveId: lastActivity.objectiveId,
                    activityId: lastActivity.activityId,
                    exerciseId: lastActivity.exerciseId,
                    deactivatedItemId: eventData,
                    graphLevel: eventData == lastActivity.objectiveId ? "objective" : "activity",
                    aiEngine: this.aiEngineToSampleActivity,
                };
                this.emit_event(String(eventType), "butler", deactivationData);
                break;
        }
    }
    emit_event(eventType, author, eventData) {
        var _a;
        const event = {
            id: (0, uuid_1.v4)(),
            createdAt: new Date().toISOString(),
            userId: this.userId,
            sessionId: this.sessionId,
            app: this.app,
            type: eventType,
            data: eventData,
            categoryData: {
                author: author,
                workmode: this.workmode,
            },
        };
        (_a = this.stream) === null || _a === void 0 ? void 0 : _a.publish(event);
    }
}
exports.EventButler = EventButler;
const getAgent = (engines, engineId) => {
    const engine = engines[engineId];
    if (!engine)
        throw new Error(`${engineId} was not instanciated`);
    return engine;
};
const getEngine = (engines, engineId) => {
    const engine = engines[engineId];
    if (!engine)
        throw new Error(`${engineId} was not instanciated`);
    return engine;
};
